import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, KiloClassType, KiloClassTypeWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateKiloClassType(): UseMutationResult<
  AxiosResponse<KiloClassType>,
  AxiosError<ErrorMessage>,
  KiloClassTypeWrite
> {
  const queryClient = useQueryClient();

  const createKiloClassType = (kiloClassType: KiloClassTypeWrite): Promise<AxiosResponse<KiloClassType>> => {
    return client.post('kilo-class-types/', kiloClassType);
  };

  return useMutation(createKiloClassType, {
    onSuccess: () => {
      queryClient.invalidateQueries('classType');
      queryClient.invalidateQueries({
        queryKey: ['classPayRateLookups'],
      });
    },
  });
}
